<ng-container *ngIf="loading"> 
  <div class="container-with-loading">
      <div class="loading-overlay">
          <mat-spinner></mat-spinner>
      </div>
  </div>
</ng-container>
<div class="login-wrapper">
  <mat-card class="card-body" appearance="outlined" [hidden]="loading">
    <mat-card-header class='headerCard'>
      <mat-card-title>
        <mat-icon>account_circle</mat-icon>Recupera tu cuenta
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="contendCard">
      <div class="contend">
        <form>
          <div class="mb-3">
            <mat-form-field class="controlHeight">
              <mat-label>Correo electr&oacute;nico</mat-label>
              <input id="email" type="email" matInput
              placeholder="ejemplo@correo.com" name="resetPassword.email" [(ngModel)]="resetPassword.email" required />
            </mat-form-field>
          </div>
        </form>
      </div>
    </mat-card-content>
    <mat-card-actions class="contendCard">
      <div >
        <button mat-flat-button class="button controlHeight" (click) ='onSubmit()'><mat-icon>search</mat-icon>Buscar</button>
      </div>
    </mat-card-actions>
    <mat-card-actions class="contendCard">
      <div >
        <button mat-flat-button class="button controlHeight" (click) ='onCancel()'><mat-icon>cancel</mat-icon>Cancelar</button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>